import * as React from "react";

import { useParams } from "react-router";
import SessionQuestions from "../../components/Classroom/SessionQuestions/SessionQuestions";
import { message, Pagination } from "antd";
import { TopBar } from "../../components/CommonComponent/Topbar";

const ScoreAndRating = () => {
  // const [dataObjects, setDataObjects] = React.useState([]);
  let { Id } = useParams();
  const [open, setOpen] = React.useState(false);
  var userId = localStorage.getItem("UserId");

  const [QuestionsPerSession, setQuestionsPerSession] = React.useState([]);
  const [rerender, setRerender] = React.useState(false);
  const [pageNumber, setPageNumber] = React.useState(0);
  const [selectedSessions, setSelectedSessions] = React.useState([]);

  const handleCheckboxChange = (sessionId) => (event) => {
    if (event.target.checked) {
      setSelectedSessions((prevSelectedSessions) => [
        ...prevSelectedSessions,
        sessionId,
      ]);
    } else {
      setSelectedSessions((prevSelectedSessions) =>
        prevSelectedSessions.filter((id) => id !== sessionId)
      );
    }
  };

  // console.log("selectedSessions",selectedSessions);

  const getData = async () => {
    // let userId = localStorage.getItem("UserId");
    return await fetch(
      `${process.env.REACT_APP_API_ROOT}/api/bot/getchats/?UserId=${userId}`,
      {
        headers: { Authorization: "Bearer " + localStorage.getItem("token") },
      }
    ).then((data) => {
      return data.json();
    });
  };

  React.useEffect(() => {
    getData().then((items) => {
    
      const grouped = {};
      console.log(items)

      for (let i = 0; i < items.message.length; i++) {
        const item = items.message[i];
        const sessionId = item.SessionId;

        if (!grouped[sessionId]) {
          grouped[sessionId] = [];
        }

        item.Chat.forEach((chatEntry) => {
          grouped[sessionId].push({
            Answer: chatEntry.Answer,
            Question: chatEntry.Question,
            BotId: item.BotId,
            ChatId: chatEntry.ChatId,
            AddBetterAnswer:chatEntry.AddBetterAnswer,
            ChatDateTime: chatEntry.ChatDateTime,
            Chat: chatEntry,
            Rating: chatEntry.Rating,
          });
        });
      }

      const keyValuePairs = Object.keys(grouped).map((key) => ({
        sessionId: key,
        data: grouped[key],
      }));
      setQuestionsPerSession(keyValuePairs.reverse());
    });
  }, [open, rerender]);

  const goToPage = (e, page) => {
    setPageNumber(page - 1);
    console.log(page);
  };

  const exportQuestions = async () => {
    

    return await fetch(
      `${process.env.REACT_APP_API_ROOT}/api/bot/exportchat/?UserId=${userId}`,
      {
        headers: {
          "content-type": "text/csv",
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      }
    )
      .then((data) => {
        return data.text();
      })
      .then((response) => {
        downloadBlob(response, "export.csv", "text/csv;charset=utf-8;");
        return response;
      });
  };

  const downloadBlob = (content, filename, contentType) => {
    var blob = new Blob([content], { type: contentType });
    var url = URL.createObjectURL(blob);
    var pom = document.createElement("a");
    pom.href = url;
    pom.setAttribute("download", filename);
    message.success("Exported successfully!")
    pom.click();
  };

  const pageSize = 10;

  const handlePageChange = (page) => {
    setPageNumber(page);
  };

  const paginatedData = Array.isArray(QuestionsPerSession)
    ? QuestionsPerSession.slice((pageNumber - 1) * pageSize, pageNumber * pageSize)
    : [];

  // const handleClick = (event) => {
  //   hiddenFileInput.current.click();
  // };

  // const handleImportFileChange = async (event) => {
  //   // const MIN_FILE_SIZE = 1; // 1KB
  //   // const MAX_FILE_SIZE = 300; // 300KB

  //   // let success = false;
  //   var formData = new FormData()
  //   formData.append("file", event.target.files[0])
  //   setFile(event.target.files[0]);
  //   return await fetch(`${process.env.REACT_APP_API_ROOT}/api/bot/importexportchat/`, {
  //     method: "POST",
  //     headers: {
  //     Authorization: "Bearer " + localStorage.getItem("token")
  //   },
  //   body: formData
  //   })
  //   .then((data) => {
  //     return data.json();
  //   })
  //   .then((response) => {
  //     console.log("Response is : ", response)
  //     return response
  //   });

  // };

  return (
    <>
      <TopBar text="Score and Rating" />
      <div className="py-8 px-8">
        <div className="p-4 bg-white">
          <div className="justify-between flex items-center w-full">
          <div>
          <p className="font-bold">
           My Conversations
          </p>
          <p>
            Here is the list of conversation sessions
          </p>
          </div>
          
          <button
            className="px-3 py-2 primary mb-4 float-right mr-3"
            onClick={exportQuestions}
          >
            Export CSV
          </button>
          </div>
          {Array.isArray(QuestionsPerSession)
        ? QuestionsPerSession.slice(pageNumber * 10, pageNumber * 10 + 10).map(
            (pair) => (
              <SessionQuestions
                open={open}
                fromRating={true}
                setOpen={setOpen}
                dataObjects={pair.data}
                Id={Id}
                SessionId={pair.sessionId}
                rerender={rerender}
                setRerender={setRerender}
                handleCheckboxChange={handleCheckboxChange(pair.sessionId)}
                isChecked={selectedSessions.includes(pair.sessionId)}
              />
            )
          )

          
        : null}
        </div>
      </div>
     <div className="flex justify-center mb-4">
      <Pagination
            current={pageNumber}
            pageSize={pageSize}
            total={paginatedData.length}
            onChange={handlePageChange}
            showSizeChanger={false}
          />
          </div>

     
    </>
  );
};

export default ScoreAndRating;
